module.exports = __webpack_public_path__ + "img/newbg.9b4ab54b.png";